// extracted by mini-css-extract-plugin
module.exports = {"photoPanel":"wmcgjno+IeiBVnDkdUUDhA==","photo":"V0Taiw0L7loQryz0c9cLLQ==","photoTitle":"UIZt7rLiRNR0Dbq+wkD3bg==","photoComment":"OwHBEWD76ZfJWq+RDndL8w=="};